const MyLoadingScreen = () => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1002]"
      style={{ backdropFilter: "blur(5px)" }}
    >
      <div className="text-center">
        <div className="loader mx-auto mb-4"></div>
      </div>
      <style>
        {`
      .loader {
        border: 4px solid rgba(255, 255, 255, 0.2);
        border-left-color: white;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    `}
      </style>
    </div>
  );
};

export default MyLoadingScreen;
